export default __webpack_public_path__ + "static/media/logoAdeme.c2a28119.svg";